import React, { useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { BoxExtendedProps } from '@common-fe/common-fe';

import { ACCEPTED_FILE_TYPES, MAX_SIZE_OF_FILE } from '@/common/constants';
import useOnDrop, { UseOnDropProps } from '@/components/controls/DropScan/useOnDrop';

import DropScanContent from './DropScanContent';

export interface DropScanProps extends UseOnDropProps {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  isCenterTitle?: boolean;
  wrapperProps?: BoxExtendedProps;
  contentWrapperProps?: BoxExtendedProps;
  additionalAction?: () => void;
  contentRenderWrapper?: (isLoading?: boolean) => React.ReactNode;
}

export const DropScan: React.FC<DropScanProps> = ({
  onFilesAdded,
  icon,
  title,
  isCenterTitle,
  wrapperProps,
  contentWrapperProps,
  additionalAction,
  onFilesSelect,
  onFileUploadError,
  contentRenderWrapper,
  storeKey,
  disableFilesUpload,
  ocrRequired,
}) => {
  const { onDrop, isLoading } = useOnDrop({
    onFilesAdded,
    onFilesSelect,
    onFileUploadError,
    disableFilesUpload,
    storeKey,
    ocrRequired,
  });

  const dropzoneProps = useDropzone({
    accept: ACCEPTED_FILE_TYPES,
    onDrop,
    maxSize: MAX_SIZE_OF_FILE,
  });

  useEffect(() => {
    if (additionalAction) {
      additionalAction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DropScanContent
      title={title}
      icon={icon}
      wrapperProps={wrapperProps}
      contentWrapperProps={contentWrapperProps}
      isCenterTitle={isCenterTitle}
      onFilesSelect={onFilesSelect}
      onFileUploadError={onFileUploadError}
      additionalAction={additionalAction}
      isLoading={isLoading}
      contentRenderWrapper={contentRenderWrapper}
      {...dropzoneProps}
    />
  );
};

export default DropScan;
